import React from 'react';
import { translate } from 'react-i18next';

/**
 * Full-page offline fallback rendered when the user navigates to an area
 * outside the offline-capable schedule zone (account, timesheets, etc.).
 * Mirrors the admin-web "You're offline" interstitial pattern.
 */
class OfflineUnavailableView extends React.Component {
  _goToSchedule() {
    Utils.getBrowserHistory().push('/schedule');
  }

  render() {
    const { t } = this.props;
    return (
      <section id="offline-unavailable" className="offline-unavailable">
        <div className="offline-unavailable__content">
          <p className="offline-unavailable__message">
            {t('OfflineUnavailableView.message')}
          </p>
          <button
            className="button button--recommended offline-unavailable__cta"
            onClick={this._goToSchedule}
          >
            {t('OfflineUnavailableView.stay_on_schedule')}
          </button>
        </div>
      </section>
    );
  }
}

export default translate()(OfflineUnavailableView);
